export default __webpack_public_path__ + "464a91ed1ddc8a0149ca499b3276fe5e.jpg";